<template>
  <div id="main" class="d-f-m">
    <div class="main_content">
      <div class="main_visual">
        <main-visual />
      </div>
      <div class="notice_swiper">
        <swiper class="m_notice_area" :navigation="swiperNavi" :loop="true" :initial-slide="0" :simulateTouch="false" :allowTouchMove="false" ref="swiperMainNotice" :modules="modules">
          <swiper-slide>
            <ul>
              <li class="w-100">
                <div class="m_notice pb-0">
                  <div class="tit_area">
                    <div class="tit">{{ $t('front.common.notice') }}</div>
                    <div class="d-f">
                      <button class="notice-swiper-prev">
                        <img src="@/assets/img/core/back.png" alt="" />
                      </button>
                      <button class="notice-swiper-next">
                        <img src="@/assets/img/core/next.png" alt="" />
                      </button>
                    </div>
                  </div>
                  <div class="list">
                    <template v-if="mainInfo.boardList.length !== 0">
                      <router-link v-for="item in mainInfo.boardList" :key="item.boardidx" :to="{ name: 'noticedetail', params: { boardIdx: item.boardIdx } }">
                        <img src="@/assets/img/core/megaphone.png" alt="" />
                        <strong>{{ item.title }}</strong>
                        <span>{{ getDateStr(item.regDate) }}</span>
                      </router-link>
                    </template>
                    <template v-else>
                      <a>
                        {{ $t('front.common.noHistory') }}
                      </a>
                    </template>
                  </div>
                </div>
              </li>
            </ul>
          </swiper-slide>
          <swiper-slide>
            <ul>
              <li class="w-100">
                <div class="m_notice pb-0">
                  <div class="tit_area">
                    <div class="tit">{{ $t('front.common.event') }}</div>
                    <div class="d-f">
                      <button class="notice-swiper-prev">
                        <img src="@/assets/img/core/back.png" alt="" />
                      </button>
                      <button class="notice-swiper-next">
                        <img src="@/assets/img/core/next.png" alt="" />
                      </button>
                    </div>
                  </div>
                  <div class="list">
                    <template v-if="mainInfo.eventList.length !== 0">
                      <router-link v-for="item in mainInfo.eventList" :key="item.boardidx" :to="{ name: 'eventdetail', params: { boardIdx: item.boardIdx } }">
                        <img src="@/assets/img/core/megaphone.png" alt="" />
                        <strong>{{ item.title }}</strong>
                        <span>{{ getDateStr(item.regDate) }}</span>
                      </router-link>
                    </template>
                    <template v-else>
                      <a>
                        {{ $t('front.common.noHistory') }}
                      </a>
                    </template>
                  </div>
                </div>
              </li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="main_img">
      <div class="m_casino_area">
        <ul>
          <li>
            <div class="m_casino" @click="openGameWelcome('Casino')">
              <p class="heading">LIVE CASINO
                <span>{{ $t('front.gameCategory.casino') }}</span>
              </p>
              <p class="img"></p>
              <p class="c_mask"></p>
              <strong>PLAY
                <img src="@/assets/img/core/next_1.png" alt="" />
              </strong>
            </div>
          </li>
          <li>
            <div class="m_casino" @click="openGameWelcome('Slot')">
              <p class="heading">SLOT GAME
                <span>{{ $t('front.gameCategory.slot') }}</span>
              </p>
              <p class="img"></p>
              <p class="c_mask"></p>
              <strong>PLAY
                <img src="@/assets/img/core/next_1.png" alt="" />
              </strong>
            </div>
          </li>
          <li>
            <div class="m_casino" @click="openGameWelcome('Sports')">
              <p class="heading">SPORTS GAME
                <span>{{ $t('front.gameCategory.sports') }}</span>
              </p>
              <p class="img"></p>
              <p class="c_mask"></p>
              <strong>PLAY
                <img src="@/assets/img/core/next_1.png" alt="" />
              </strong>
            </div>
          </li>
          <li>
            <div class="m_casino" @click="openGameWelcome('Mini')">
              <p class="heading">MINI GAME
                <span>{{ $t('front.gameCategory.minigame') }}</span>
              </p>
              <p class="img"></p>
              <p class="c_mask"></p>
              <strong>PLAY
                <img src="@/assets/img/core/next_1.png" alt="" />
              </strong>
            </div>
          </li>
        </ul>
      </div>
      <div class="main_games">
        <div class="game_list">
          <ul class="list_area swiper-pagination"></ul>
        </div>
        <swiper :loop="true" :initial-slide="0" :simulateTouch="false" :allowTouchMove="false" :autoplay="{ delay: 100000,disableOnInteraction: false }" ref="gameListSwiper" :modules="modules" :pagination="gamesSwiperPagination">
          <swiper-slide class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-for="(game, index) in casinoVendors" :key="game.code">
                  <li v-if="index < 5">
                    <div class="m_miniGames" @click="getCasinoUrl(game.procId, game.lobbySymbol)">
                      <img class="productLogo" :src="loadLogoImg(game.procId)" />
                      <p class="logo">
                        <a href="#" class="myButton_sports">{{ $t(`front.gameCode.${game.groupCode}.${game.procId}`) }}</a>
                      </p>
                      <img v-if="game.groupCode !== 'minigame'" :src="loadGameImage(`Main_${game.groupCode}_list_${index + 1}.jpg`)" />
                      <img v-else :src="loadGameImage(`Main_${game.groupCode}_list_${game.procId}.jpg`)" />
                      <p class="c_mask"></p>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </swiper-slide>
          <swiper-slide class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-for="(game, index) in slotVendors" :key="game.code">
                  <li v-if="index < 5">
                    <div class="m_miniGames" @click="getSlotList(game.procId)">
                      <img class="productLogo" :src="loadLogoImg(game.procId)" />
                      <p class="logo">
                        <a href="#" class="myButton_sports">{{ $t(`front.gameCode.${game.groupCode}.${game.procId}`) }}</a>
                      </p>
                      <img v-if="game.groupCode !== 'minigame'" :src="loadGameImage(`Main_${game.groupCode}_list_${index + 1}.jpg`)" />
                      <img v-else :src="loadGameImage(`Main_${game.groupCode}_list_${game.procId}.jpg`)" />
                      <p class="c_mask"></p>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </swiper-slide>
          <swiper-slide class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-for="(game, index) in sportsVendors" :key="game.code">
                  <li v-if="index < 5">
                    <div class="m_miniGames" @click="goPageSports(game.procId,game.procId)">
                      <img class="productLogo" :src="loadLogoImg(game.procId)" />
                      <p class="logo"><a href="#" class="myButton_sports">{{ $t(`front.gameCode.${game.groupCode}.${game.procId}`) }}</a></p>
                      <img v-if="game.groupCode !== 'minigame'" :src="loadGameImage(`Main_${game.groupCode}_list_${index + 1}.jpg`)" />
                      <img v-else :src="loadGameImage(`Main_${game.groupCode}_list_${game.procId}.jpg`)" />
                      <p class="c_mask"></p>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </swiper-slide>
          <swiper-slide class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-for="(game, index) in minigameVendors" :key="game.code">
                  <li v-if="index < 5">
                    <div class="m_miniGames" @click="_getMiniGameUrl(game.procId)">
                      <img class="productLogo" :src="loadLogoImg(game.procId)" />
                      <p class="logo">
                        <a href="#" class="myButton_sports">{{ $t(`front.gameCode.${game.groupCode}.${game.procId}`) }}</a>
                      </p>
                      <img :src="loadGameImage(`Main_${game.groupCode}_list_${game.procId}.jpg`)" />
                      <p class="c_mask"></p>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="m_notice_area">
        <ul>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t('front.common.notice') }}</div>
              <div class="list">
                <template v-if="mainInfo.boardList.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'" :pause="mainInfo.boardList.length < 5">
                    <router-link v-for="item in mainInfo.boardList" :key="item.boardidx" :to="{ name: 'noticedetail', params: { boardIdx: item.boardIdx } }">
                      <strong>{{ item.title }}</strong>
                      <span>{{ getDateStr(item.regDate) }}</span>
                    </router-link>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t(`front.main.livecharge`) }}</div>
              <div class="list">
                <template v-if="mainInfo.cashListIn.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'">
                    <a v-for="item in mainInfo.cashListIn" :key="item.cashIdx">
                      <strong>{{ convertAnonymous(item.memId, 4, '*') }}</strong>
                      <span class="green">{{ thousand(item.cashAmt) }}</span>
                      <span>{{ getDateStr(item.updDate) }}</span>
                    </a>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t(`front.main.liveExchange`) }}</div>
              <div class="list">
                <template v-if="mainInfo.cashListOut.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'">
                    <a v-for="item in mainInfo.cashListOut" :key="item.cashIdx">
                      <strong>{{ convertAnonymous(item.memId, 4, '*') }}</strong>
                      <span class="green">{{ thousand(Math.abs(item.cashAmt)) }}</span>
                      <span>{{ getDateStr(item.updDate) }}</span>
                    </a>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="mainPopWrap">
    <template v-for="(item) in popupList" v-bind:key="item.bannerIdx">
      <div class="mainPop" :class="`pop-position--${item.bannerPosition}`" v-if="item.delYn == 'N' && !item.isClose" :data-idx="item.bannerIdx">
        <div class="closeWrap">
          <a class="close" @click="popupCloseByCookie(item)">{{ $t('front.main.today') }}</a>
          <a class="close" @click="popupClose(item)">{{ $t('front.main.close') }}</a>
        </div>
        <a target="_blank" :href="item.domain" v-if="item.domain" class="redirect_link"></a>
        <!-- <img :src="item.bannerImg" /> -->
        <editor-viewer ref="editor" :content="item.bannerImg" />
      </div>
    </template>
  </div>
  <div class="slot-game-list-modal" v-if="activeGameList">
    <div class="slot_list">
      <div class="slot-game-list-header">
        <button type="button" @click="gameListMoalClose">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <ul>
        <template v-for="item in gameList" :key="item.symbol">
          <li @click="getSlotUrl(item)">
            <div class="img">
              <img :src="item.imgSrc" :alt="item.symbol" />
            </div>
            <div class="tit">
              <span> {{ item.gameName }} </span>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
// import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation'
import { Pagination, Autoplay, Navigation } from 'swiper/modules'
import { getPopupCookie, setPopupCookie, tokenCheck } from '@/libs/auth-helper'
import { getMain, getMainCashStatus, getMainNotice } from '@/api/main'
import { mapState } from 'vuex'
import MainVisual from '@/components/common/MainVisual.vue'
import store from '@/store'
import { thousand, getDateStr, convertAnonymous, isMobile } from '@/libs/utils'
import { Vue3Marquee } from 'vue3-marquee'
import EditorViewer from '@/components/EditorViewer'
import { getGameUrlCasino, getGameList, getGameUrlSlot, getMiniGameUrl } from '@/api/game'

export default {
  name: 'Index.vue',
  components: {
    MainVisual,
    Vue3Marquee,
    Swiper,
    SwiperSlide,
    EditorViewer
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation]
    }
  },
  async created() {
    this.loadMain()
    this.popupMerge()
  },
  data() {
    return {
      swiperNavi: {
        enabled: true,
        nextEl: '.notice-swiper-next',
        prevEl: '.notice-swiper-prev'
      },
      gamesSwiperPagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: (index, className) => {
          const title = ['CASINO', 'SLOT', 'SPORTS', 'MINIGAME']
          return `<li class="${className} main-game-list-item">${title[index]}</li>`
        }
      },
      gameActive: 'casino',
      currentTab: 'tab-1',
      popupList: {},
      cashInList: [],
      cashOutList: [],
      noticeList: [],
      listMaxCount: 5,
      boardList: [],
      eventList: [],
      cashListIn: [],
      cashListOut: [],
      playState: 'playing',
      gameList: null,
      slotList: [],
      activeSlotList: '',
      activeGameList: false,
      gameListStatus: false
    }
  },
  watch: {
    popup() {
      this.popupMerge()
    },
    popupLogin() {
      this.popupMerge()
    },
    async userData() {
      await store.dispatch('storePopup')
      if (this.userData) {
        await store.dispatch('storePopupLogin')
      }
      this.popupMerge()
    }
  },
  computed: {
    ...mapState([
      'userData',
      'commonCode',
      'commonCodeByOrder',
      'gameGroupCodes',
      'popup',
      'popupLogin',
      'banner',
      'gameCount',
      'productList',
      'mainInfo'
    ]),
    slotVendors() {
      return this.productList.filter(item => item.groupCode === 'slot')
    },
    casinoVendors() {
      return this.productList.filter(item => item.groupCode === 'casino')
    },
    minigameVendors() {
      return this.productList.filter(item => item.groupCode === 'minigame')
    },
    sportsVendors() {
      return this.productList.filter(item => item.groupCode === 'sports')
    }
  },
  methods: {
    gameListMoalOpen() {
      this.activeGameList = true
    },
    gameListMoalClose() {
      this.activeGameList = false
      this.activeSlotList = ''
    },
    goSports(procId) {
      let target = ''
      switch (procId) {
        case 'api77':
          target = 'sportsInternal'
          break
        case 'bti':
          target = 'sportsBti'
          break
        case 'pinacle':
          target = 'sportsOverseas'
          break
        case 'inplay':
          target = 'sportsInplay'
          break
      }
      this.$router.push({ name: target })
    },
    async listParser(gameList) {
      this.gameList = []

      for (const item of gameList) {
        const slotObject = {
          symbol: item.code,
          gameName: this.$i18n.locale === 'ko' ? item.name_KOR : item.name_ENG,
          imgSrc: item.thumbnail
        }
        this.gameList.push(slotObject)
      }
    },
    async getSlotList(vendorKey) {
      // const msg = '로그인 이후 이용 가능합니다.'
      const msg = this.$t('front.error.afterSignin')
      if (!this.userData) {
        alert(msg)
        return
      }
      this.emitter.emit('Loading', true)
      this.activeSlotList = vendorKey
      const params = {
        vendorKey: vendorKey,
        gameType: 'slot',
        siteId: this.userData.siteId
      }
      try {
        const response = await getGameList(params)
        // const response = slotList
        // console.log(response)
        const { resultCode, resultMessage, data } = response.data
        if (resultCode === '200' && resultMessage === 'SUCCESS') {
          const { gameList } = data
          await this.listParser(gameList)
          this.gameListMoalOpen()
        } else {
          // alert('게임 목록을 불러오는데 실패했습니다.')
          alert(this.$t('front.main.failedGames'))
          console.log(typeof resultCode, resultMessage)
          throw new Error('get pp game list fail')
        }
      } catch (e) {
        console.error(e)
      }
      this.emitter.emit('Loading', false)
    },
    async getSlotUrl(item) {
      // const msg = '로그인 이후 이용 가능합니다.'
      const msg = this.$t('front.error.afterSignin')
      if (!this.userData) {
        alert(msg)
        return
      }
      const gameWindow = window.open('/preload', '_blank', 'width=1280,height=720')
      this.emitter.emit('Loading', true)
      const params = {
        vendorKey: this.gameVendor,
        gameKey: item.symbol,
        isMobile: isMobile() ? '1' : '0',
        lang: this.$i18n.locale
      }
      try {
        // evolution test용
        let response = null
        response = await getGameUrlSlot(params)
        const { resultCode, resultMessage, data } = response.data
        if (resultCode === '200' && resultMessage === 'SUCCESS') {
          gameWindow.location.href = data.gameUrl
          this.emitter.emit('Loading', false)
        } else {
          gameWindow.close()
          throw new Error(this.$t(`api.${resultCode}`))
        }
      } catch (e) {
        alert(e.message)
        console.log(e)
        // console.log(this.$router)
      }
      this.emitter.emit('Loading', false)
    },
    loadLogoImg(procId) {
      // console.log(procId)
      try {
        return require(`@/assets/img/logo/${procId}-1.png`)
      } catch (e) {
        // console.log(e)
        return ''
      }
    },
    async _getMiniGameUrl(game) {
      // const msg = '로그인 이후 이용 가능합니다.'
      const msg = this.$t('front.error.afterSignin')
      if (!this.userData) {
        alert(msg)
        return
      }
      const device = ((device) => {
        let _device = '0'
        if (device) {
          _device = '1'
        }
        return _device
      })(isMobile())
      const reqModel = {
        siteName: this.siteName,
        id: this.userId,
        isMobile: device,
        lang: this.$i18n.locale
      }
      const windowSize = {
        coin5: 'width=1170px,height=920px',
        coin3: 'width=1170px,height=920px',
        pbg: 'width=1140px,height=880px',
        default: 'width=1140px,height=855px'
      }
      try {
        const gameWindow = window.open('/preload', '_blank', windowSize[game] || windowSize.default)
        this.emitter.emit('Loading', true)
        const response = await getMiniGameUrl(game, reqModel)
        const { data } = response.data
        if (data.gameurl) {
          gameWindow.location.href = data.gameurl
          this.emitter.emit('Loading', false)
        }
      } catch (e) {
        console.error(e)
      }
      this.emitter.emit('Loading', false)
    },
    async getCasinoUrl(procId, gameKey) {
      // const msg = '로그인 이후 이용 가능합니다.'
      const msg = this.$t('front.error.afterSignin')
      if (!this.userData) {
        alert(msg)
        return
      }
      const gameWindow = window.open('/preload', '_blank', 'width=1280,height=720')
      this.emitter.emit('Loading', false)
      const params = {
        vendorKey: procId,
        isMobile: isMobile() ? '1' : '0',
        gameKey: gameKey,
        lang: this.$i18n.locale
      }
      try {
        for (const key in params) {
          if (!params[key]) delete params[key]
        }
        const response = await getGameUrlCasino(params)
        const { resultCode, resultMessage, data } = response.data
        if (resultCode === '200' && resultMessage === 'SUCCESS') {
          gameWindow.location.href = data.gameUrl
          this.emitter.emit('Loading', false)
        } else {
          gameWindow.close()
          throw new Error(this.$t(`api.${resultCode}`))
        }
      } catch (e) {
        alert(e.message)
        console.log(e)
        // console.log(this.$router)
      }
      this.emitter.emit('Loading', false)
    },
    async openGameWelcome(value) {
      this.emitter.emit('Loading', true)
      await store.dispatch('storeGameComponent', value)
      this.emitter.emit('Loading', false)
    },
    convertAnonymous,
    getDateStr,
    thousand,
    loadCashStatus() {
      getMainCashStatus({}).then(res => {
        const result = res.data
        if (result.resultCode === '200') {
          console.log(result.data)
          this.cashInList = result.data.cashInList
          this.cashOutList = result.data.cashOutList
        }
      })
    },
    loadNotice() {
      getMainNotice({}).then(res => {
        const result = res.data
        if (result.resultCode === '200') {
          this.noticeList = result.data.noticelist
        }
      })
    },
    getBackgroundImage(item) {
      try {
        const image = require('../assets/img/game_main_pc_' + item.code + '_off.png')
        const imageOff = require('../assets/img/game_main_pc_' + item.code + '_off.png')
        if (image && imageOff) {
          if (item.isHover) {
            return { backgroundImage: 'url(' + image + ')' }
          } else {
            return { backgroundImage: 'url(' + imageOff + ')' }
          }
        } else {
          return { backgroundImage: 'url()' }
        }
      } catch (e) {
        return { backgroundImage: 'url()' }
      }
    },
    getBackgroundLogoImage(item) {
      try {
        const image = require('../assets/img/glogo' + item.code + '.png')
        return { backgroundImage: 'url(' + image + ')' }
      } catch (e) {
        return { backgroundImage: 'url()' }
      }
    },
    goPageSports(vendor, gameCode) {
      this.$router.push({ name: 'sportsViewer', params: { vendor: vendor, gameCode: gameCode } })
    },
    goPage(procId) {
      this.$router.push({ name: 'minigameViewer', params: { gameCode: procId } })
    },
    loadGameImage(url) {
      const _url = url
      try {
        const image = require('../assets/img/core/' + _url)
        return image
      } catch (e) {
        return null
      }
    },
    popupMerge() {
      const popupLogin = this.userData ? this.popupLogin : []
      const pList = this.popup.concat(popupLogin)

      this.popupList = {}

      pList.forEach(item => {
        if (!item.isClose) {
          const key = item.bannerIdx
          const siteId = process.env.VUE_APP_SITE_ID || 'moka'
          const name = siteId + '_popup_' + item.bannerIdx
          const cookie = getPopupCookie(name)
          if (cookie) {
            item.isClose = true
          } else {
            item.isClose = false
          }
          if (!this.popupList[key]) {
            this.popupList[key] = item
          }
        }
      })
    },
    popupClose(item) {
      item.isClose = true
    },
    popupCloseByCookie(item) {
      item.isClose = true
      setPopupCookie(item)
    },
    slotOpen(event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
      this.emitter.emit('Loading', false)
    },
    loadMain() {
      if (this.userData) {
        getMain({}).then(res => {
          // console.log(res)
        })
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    await tokenCheck()
    // if (result) {
    next()
    // }
  }
}
</script>

<!-- <style src="@/styles/winner_pc/common.css"></style> -->
<style src="@/styles/winner_pc/main.css"></style><!-- <style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/main.css"></style> -->
<style>
.main-game-list-item {
  background-color: unset; /* Bullet의 배경색 */ /* Bullet의 텍스트 색상 */
  width: auto;
  height: auto; /* Bullet의 너비 자동 조절 */
  padding: unset; /* Bullet의 패딩 */
  border-radius: unset; /* Bullet의 모서리 둥글게 */
  font-size: 16px; /* Bullet의 텍스트 크기 */
  margin: unset; /* Bullet 간의 간격 */
  opacity: 1;
}

/* Active 상태일 때의 Bullet 스타일 */
#main .list_area li.swiper-pagination-bullet-active {
  color: #fff;
  border-color: #26234c;
  text-shadow: 2px 2px 2px #26234c; /* Active Bullet의 배경색 */
}
</style>
<style scoped>
.vue3-marquee {
  width: 100%;
  height: 100%;
}

.marquee {
  width: 100%;
}

#main .m_notice .list {
  min-height: 300px;
  height: 320px;
  overflow: hidden;
}

.mainPopWrap {
  display: flex;
  align-items: center;
  gap: 50px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1005;
}

.mainPop {
  position: relative;
  min-width: 320px;
  background: #fff;
  border: 1px solid #777;
  z-index: 100;
}

.mainPop a.redirect_link {
  width: 100%;
  height: 640px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.mainPop .closeWrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
  position: absolute;
  bottom: 0;
  padding: 15px;
  background: rgba(0, 0, 0, .7);
  color: #fff;
  font-size: 12px;
  z-index: 2;
}

.mainPop a.close {
  color: #fff;
}

.mainPop > img {
  width: 430px;
  height: 640px;
  vertical-align: bottom;
  object-fit: cover;
  object-position: center;
}

.notice-swiper-prev,
.notice-swiper-prev {
  padding-right: 0;
}

#main .main_games .list_area {
  position: relative;
}

.pop-position--A,
.pop-position--B,
.pop-position--C {
  position: absolute;
}

.pop-position--A {
  transform: translateX(-60%);
  right: 100%;

}

.pop-position--B {
  left: -50%;
  transform: translateX(-50%);
}

.pop-position--C {
  transform: translateX(60%);
  left: -100%;
}
</style>
<style scoped lang="scss" src="@/styles/game.scss"></style>
